import {Component, Input} from '@angular/core';
import {WebDokuNodeValue} from "../../models/web-doku-node-value";
import {NodeValueTreeItem} from "../../models/node-value-tree-item";

@Component({
    selector: 'ldw-node-value-list-view',
    templateUrl: './node-value-list-view.component.html',
    styleUrls: ['./node-value-list-view.component.css'],
    standalone: false
})
export class NodeValueListViewComponent {

  private _list: WebDokuNodeValue[] = [];
  _tree: NodeValueTreeItem[] = [];

  private static compare(a: WebDokuNodeValue, b: WebDokuNodeValue) {
    // first compare by area
    if (a.area < b.area) {
      return -1;
    }
    if (a.area > b.area) {
      return 1;
    }
    // then by group
    if (a.group < b.group) {
      return -1;
    }
    if (a.group > b.group) {
      return 1;
    }
    // at last by caption
    if (a.caption < b.caption) {
      return -1;
    }
    if (a.caption > b.caption) {
      return 1;
    }
    // same area, group and caption mean equal
    return 0;
  }


  @Input()
  get list(): WebDokuNodeValue[] | undefined {
    return this._list;
  }

  set list(value: WebDokuNodeValue[] | undefined) {
    if (this._list == value) {
      return;
    }
    if (value == undefined) {
      this._list = [];
    } else {
      this._list = value;
    }
    this.processList();
  }

  private processList() {
    this._tree = [];
    if (this._list == undefined || this._list.length == 0) {
      return;
    }
    const temp = [];

    // first sort list by area, group, caption
    const sorted = this._list.sort(NodeValueListViewComponent.compare);

    // add first element
    let level1 = new NodeValueTreeItem();
    let level2 = new NodeValueTreeItem();
    level1.text = sorted[0].area;
    level2.text = sorted[0].group;
    level1.nodes.push(level2);
    level2.values.push(sorted[0]);
    temp.push(level1);

    for (let i = 1; i < sorted.length; i++) {
      const current = sorted[i];
      if (current.area != level1.text) {
        // different area => add complete new root node
        level1 = new NodeValueTreeItem();
        level2 = new NodeValueTreeItem();
        level1.text = current.area;
        level2.text = current.group;
        level1.nodes.push(level2);
        level2.values.push(current);
        temp.push(level1);
      } else {
        if (current.group != level2.text) {
          // different group (but same area) => add new group node to current area node
          level2 = new NodeValueTreeItem();
          level2.text = current.group;
          level2.values.push(current);
          level1.nodes.push(level2);
        } else {
          // same area and group => just add item to current group node
          level2.values.push(current);
        }
      }
    }
    this._tree = temp;
  }


}


